import Styles from './Carousels.module.scss'
import { Carousel } from 'components/Carousel/Carousel'
import { LoadingShimmerer } from 'components/LoadingShimmerer/LoadingShimmerer'

export const LoadingCarousel = () => {
  return (
    <Carousel slideGap={7} paddingLeft="15px" paddingRight="15px">
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className={Styles.mediaFileContainer} data-testid="loading-carousel">
          <LoadingShimmerer className={Styles.placeholder} borderRadius={6} />
        </div>
      ))}
    </Carousel>
  )
}
